import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Logo from './Logo';
import UserMenu from './UserMenu';
import { Box, Button } from '@mui/material';

const ResponsiveAppBar = () => {

  return (
    <AppBar
      style={{
        backgroundColor: '#fff'
      }}
      elevation={0}
      position="relative"
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Logo sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            &nbsp;
          </Box>
          <Logo sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            &nbsp;
          </Box>
          <Button
            href='https://vimeo.com/758803491'
            target='_vimeo'
          >FAQ</Button>
          <UserMenu />
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;
